<template>
  <div>
    <particlesHeader :Title="'Contact Me'" :Size="13" />
    <section class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="form-container glass-background padded-with-20 animatable-component">
              <div class="form_main">
                <div class="form">
                  <form id="contactFrm" name="contactFrm" autocomplete="off">
                    <span
                      class="validation-message pink-bold-font name-validation-message disappeared"
                      :class="{appeared : Touched &&  !Validation.name}"
                    >
                      Name Is not
                      valid
                    </span>
                    <input
                      type="text"
                      placeholder="Please Enter your Name"
                      value
                      name="name"
                      class="txt name-input animatable-component"
                      id="name-field"
                      autocomplete="off"
                      v-model="Model.name"
                    />

                    <span
                      class="validation-message pink-bold-font email-validation-message disappeared"
                      :class="{appeared : Touched &&  !Validation.email}"
                    >
                      email Is not
                      valid
                    </span>
                    <input
                      type="text"
                      placeholder="Please Enter your Email"
                      value
                      name="email"
                      class="txt email-input animatable-component"
                      id="email-field"
                      autocomplete="off"
                      v-model="Model.email"
                    />

                    <span
                      class="validation-message pink-bold-font message-field-validation-message disappeared"
                      :class="{appeared : Touched &&  !Validation.message}"
                    >
                      Message
                      Is not valid
                    </span>
                    <textarea
                      placeholder="Your Message"
                      name="mess"
                      type="text"
                      class="txt_3 message-input animatable-component"
                      id="message-field"
                      autocomplete="off"
                      v-model="Model.message"
                    ></textarea>

                    <div class="submit-wrapper">
                      <input
                        type="button"
                        value="submit"
                        name="submit"
                        autocomplete="off"
                        class="txt2 submit-input send-email-button animatable-component"
                        v-if="!Sent && !IsSending"
                        @click="SendMessage"
                      />
                    </div>
                  </form>
                </div>
              </div>

              <div class="loading-container" v-show="IsSending">
                <span class="loading-text">Your Email is being sent...</span>
                <div id="circleG">
                  <div id="circleG_1" class="circleG"></div>
                  <div id="circleG_2" class="circleG"></div>
                  <div id="circleG_3" class="circleG"></div>
                </div>
              </div>

              <div class="success-message-box" v-show="SubmittedSuccessfully">
                <h5>Thank you ... your message has been sent , I'll read it ASAP</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pageInlineNavigation :Next="null" :back="'About'" />
    </section>
  </div>
</template>

<script>
import particlesHeader from "../components/particlesHeader";
import pageInlineNavigation from "../components/pageInlineNavigation";
export default {
  components: { particlesHeader, pageInlineNavigation },

  data() {
    return {
      Model: {},
      Validation: {
        name: false,
        email: false,
        message: false,
      },
      Touched: false,
      SubmittedSuccessfully: false,
      IsSending: false,
      Sent: false,
      emailRegularExpression: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  methods: {
    isEmailValid: function (email) {
      return email == ""
        ? ""
        : this.emailRegularExpression.test(email)
        ? "has-success"
        : "has-error";
    },
    SendMessage: function () {
      this.Touched = true;

      this.Validation.name = true;
      this.Validation.email = true;
      this.Validation.message = true;

      if (!this.Model.name || this.Model.name.trim() == "") {
        this.Validation.name = false;
      }

      if (
        !this.Model.email ||
        this.Model.email.trim() === "" ||
        !this.isEmailValid(this.Model.email)
      ) {
        this.Validation.email = false;
      }

      if (!this.Model.message || this.Model.message.trim() == "") {
        this.Validation.message = false;
      }

      if (
        !this.Validation.name ||
        !this.Validation.email ||
        !this.Validation.message
      ) {
        return;
      }

      this.IsSending = true;
      this.$http.post("/SendEmail", this.Model).then(
        (response) => {
          if (response.status === 200) {
            this.SubmittedSuccessfully = true;
            this.IsSending = false;
            this.Sent = true;
            this.Model = {};
          }
        },
        (error) => {
          this.IsSending = false;
          this.SubmittedSuccessfully = false;
          console.error(error);
          alert(
            "Sorry ... it seems the server connot send a message right now "
          );
        }
      );
    },
  },
};
</script>

<style scoped>
.form-container {
  min-height: 400px;
}

.form_main {
  width: 100%;
}

.heading {
  border-bottom: 1px solid #fcab0e;
  padding-bottom: 9px;
  position: relative;
}

.heading span {
  background: #9e6600 none repeat scroll 0 0;
  bottom: -2px;
  height: 3px;
  left: 0;
  position: absolute;
  width: 75px;
}

.form {
  border-radius: 7px;
  padding: 6px;
}

.txt[type="text"] {
  margin: 10px 0;
  padding: 10px 0 10px 5px;
  width: 100%;
  background-color: transparent;
  border: 0px solid rgb(100, 100, 100);
  border-bottom: 1px solid rgb(100, 100, 100);
  color: white;
}

.txt_3[type="text"] {
  margin: 10px 0 0;
  padding: 10px 0 10px 5px;
  width: 100%;
  background-color: transparent;
  border: 0px solid rgb(100, 100, 100);
  border-bottom: 1px solid rgb(100, 100, 100);
  color: white;
}

.submit-wrapper {
  text-align: center;
}

.form-container ::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgb(190, 190, 190);
}

.form-container ::-moz-placeholder {
  /* Firefox 19+ */
  color: rgb(190, 190, 190);
}

.form-container :-ms-input-placeholder {
  /* IE 10+ */
  color: rgb(190, 190, 190);
}

.form-container :-moz-placeholder {
  /* Firefox 18- */
  color: rgb(190, 190, 190);
}

.submit-input {
  background-color: transparent;
  border: 0px solid #4f5c04;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
  line-height: 35px;
  margin: 10px 0;
  margin-top: 20px;
  padding: 10px;
  text-transform: uppercase;
  width: 30%;
}

.submit-input:hover {
  -webkit-box-shadow: 0px 0px 43px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 43px -1px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 43px -1px rgba(0, 0, 0, 0.75);
}

input,
textarea {
  outline: none;
}

.name-validation-message.disappeared,
.email-validation-message.disappeared,
.message-field-validation-message.disappeared {
  visibility: hidden;
}

.name-validation-message.appeared,
.email-validation-message.appeared,
.message-field-validation-message.appeared {
  visibility: visible !important;
}

.validation-message {
  color: #ff9f9f;
  font-style: italic;
}
</style>